const usTerritories = ['US', 'AS', 'GU', 'MP', 'PR', 'VI', 'United States']

export default function isCountryUs(country) {
  return usTerritories.includes(country)
}
